<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="chapter-number---IVP sigil_not_in_toc" id="_idParaDest-8"><a id="_idTextAnchor071"></a><a id="_idTextAnchor072"></a><a id="_idTextAnchor073"></a><a id="_idTextAnchor074"></a><span class="pagebreak" id="page9" title="9"></span></h2>
<h2 class="chapter-title---IVP" id="_idParaDest-9"><a id="_idTextAnchor075"></a>Acknowledgments</h2>
<p class="veryfirst"><span class="drop-cap">T</span>his book (or, in fact, my career) would not have been possible without the people who taught me church history and gave me a love for the church and her tradition. I especially want to thank my first church history professor, James E. Bradley of Fuller Theological Seminary, and my dissertation advisors, Dennis Groh and Robert Jewett of Garrett-Evangelical Theological Seminary. I would also like to thank my colleagues and students at Garrett-Evangelical for their support and trust, as well as my research assistant, Kay Hardiman, who helped with the subject index.</p>
<p class="body"><a id="_idTextAnchor076"></a><a id="_idTextAnchor077"></a><span class="pagebreak" id="page10" title="10"></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgements.vue?a4a3ec66